import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, isRef as _isRef, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "agila-radio-buttons" }
const _hoisted_2 = ["aria-label"]
const _hoisted_3 = ["id", "for"]
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["for", "id"]


import RadioButton from "primevue/radiobutton";
import useSharedFormLogic from "../helper/functions/useSharedFormLogic";
import AgilaFormError from "./agilaFormError.vue";

interface Props {
  modelValue: any;
  id: string;
  options: Array<any>;
  label?: string;
  rules?: string[];
  classes?: string;
  icon?: string;
  ariaLabel?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'agilaRadioButtons',
  props: {
    modelValue: { default: "" },
    id: { default: "" },
    options: { default: () => [] },
    label: { default: "" },
    rules: { default: () => [] },
    classes: { default: "" },
    icon: { default: "" },
    ariaLabel: { default: "" }
  },
  emits: ["update:modelValue", "update:error"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

const emit = __emit;

const { readyForCheck, inputValue, error, updateValue, validate } =
  useSharedFormLogic(props, emit);

__expose({
  validate: () => {
    readyForCheck.value = true;
    return validate(inputValue.value);
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("fieldset", {
      class: _normalizeClass(["radio-button-wrapper", props.classes]),
      role: "radiogroup",
      "aria-label": props.label ? props.label : props.ariaLabel
    }, [
      (props.label)
        ? (_openBlock(), _createElementBlock("label", {
            key: 0,
            id: props.id + '-label',
            for: props.id
          }, _toDisplayString(props.label), 9, _hoisted_3))
        : _createCommentVNode("", true),
      _createVNode(AgilaFormError, {
        error: _unref(error),
        id: props.id + '-error'
      }, null, 8, ["error", "id"]),
      _createElementVNode("div", {
        class: _normalizeClass(["radio-button-cons", { icons: props.icon }])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.options, (option) => {
          return (_openBlock(), _createElementBlock("div", {
            class: _normalizeClass(["radio-button-con", { active: _unref(inputValue) && option.id === _unref(inputValue).id }]),
            key: option.id,
            onClick: ($event: any) => {
            inputValue.value = option;
            readyForCheck.value = true;
            _unref(updateValue)();
          }
          }, [
            _createVNode(_unref(RadioButton), {
              modelValue: _unref(inputValue),
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(inputValue) ? (inputValue).value = $event : null)),
              inputId: props.id + '_' + option.id,
              name: props.id,
              value: option,
              tabindex: 0,
              invalid: !!_unref(error),
              "aria-describedby": props.id + '-error',
              "aria-labelledby": 'label_' + props.id + '_' + option.id.toString()
            }, null, 8, ["modelValue", "inputId", "name", "value", "invalid", "aria-describedby", "aria-labelledby"]),
            _createElementVNode("label", {
              for: props.id + '_' + option.id.toString(),
              id: 'label_' + props.id + '_' + option.id.toString()
            }, _toDisplayString(option.name), 9, _hoisted_5),
            (props.icon)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass({
              inactive: _unref(inputValue).id !== option.id,
              ['agila-icon-' + option[props.icon]]: true,
            })
                }, null, 2))
              : _createCommentVNode("", true)
          ], 10, _hoisted_4))
        }), 128))
      ], 2)
    ], 10, _hoisted_2)
  ]))
}
}

})